import React from "react";
import { Box, Grid } from "@material-ui/core";
import ListEkloksContainer from "../../containers/ekloks/ListEkloksContainer";
import ListInstallersContainer from "../../containers/installers/ListInstallersContainer";
import ListCustomersContainer from "../../containers/customers/ListCustomersContainer";
import ListSupportsContainer from "../../containers/support/ListSupportContainer";
import ListPlantsContainer from "../../containers/plants/ListPlantsContainer";
import PlantCard from "./PlantCard";
import CustomerCard from "./CustomerCard";
import EklokCard from "./EklokCard";
import InstallerCard from "./InstallerCard";
import SupportCard from "./SupportCard";

const AdminView = () => {
  return (
    <Box p={3} mb="5%">
      <Grid container spacing={4}>
        <Grid item xs={12} sm={6}>
          <ListPlantsContainer>
            {({ content, onViewAllAction }) => (
              <PlantCard plants={content} action={onViewAllAction} />
            )}
          </ListPlantsContainer>
        </Grid>
        <Grid item xs={12} sm={6}>
          <ListEkloksContainer>
            {({ content, onViewAllAction, updateStatus, isPending }) => (
              <EklokCard
                ekloks={content}
                action={onViewAllAction}
                updateStatus={updateStatus}
                isPending={isPending}
              />
            )}
          </ListEkloksContainer>
        </Grid>
        <Grid item xs={12} sm={6}>
          <ListInstallersContainer>
            {({ content, onViewAllAction }) => (
              <InstallerCard installers={content} action={onViewAllAction} />
            )}
          </ListInstallersContainer>
        </Grid>
        <Grid item xs={12} sm={6}>
          <ListCustomersContainer>
            {({ content, onViewAllAction }) => (
              <CustomerCard customers={content} action={onViewAllAction} />
            )}
          </ListCustomersContainer>
        </Grid>{" "}
        <Grid item xs={12} sm={6}>
          <ListSupportsContainer>
            {({ content, onViewAllAction }) => (
              <SupportCard supports={content} action={onViewAllAction} />
            )}
          </ListSupportsContainer>
        </Grid>
      </Grid>
    </Box>
  );
};

export default AdminView;
